/**
 * Configuration types for the SAE Studio engine.
 *
 * Mirrors the engine interface sketch in Section 16.4 of the implementation
 * brief, with defaults from the Section 17 configuration reference.
 * Section references are to the brief throughout this package.
 */
/** D-2 finalized validated-range triggers (Addendum 18) plus the RB-4 area floor. */
export const DEFAULT_VALIDATED_RANGE = {
    minMedianRespondents: 6,
    minModelEstimate: 0.02,
    maxModelEstimate: 0.4,
    minFittedAreas: 10,
    minMedianRespondentsNoCounts: 54,
};
/** Brief 9.7 defaults for the Fay-Herriot fit. */
export const DEFAULT_FAY_HERRIOT_FIT_CONFIG = {
    maxIterations: 100,
    convergenceTolerance: 1e-8,
    standardizeCovariates: true,
};
//# sourceMappingURL=config.js.map